"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputChannelObserver = void 0;
const EventStreamEvents_1 = require("./EventStreamEvents");
const EventType_1 = require("./EventType");
class OutputChannelObserver {
    // private inProgressDownloads:
    constructor(outputChannel) {
        this.outputChannel = outputChannel;
        this.inProgressDownloads = [];
    }
    post(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        switch (event.type) {
            case EventType_1.EventType.DotnetAcquisitionStart:
                const acquisitionStarted = event;
                this.inProgressDownloads.push(acquisitionStarted.install.installId);
                this.outputChannel.append(`${acquisitionStarted.requestingExtensionId} requested to download the ${acquisitionStarted.install.installMode === 'sdk' ? '.NET SDK' :
                    acquisitionStarted.install.installMode === 'runtime' ? '.NET Runtime' :
                        '.NET ASP.NET Runtime'}.`);
                this.outputChannel.appendLine('');
                if (((_b = (_a = this.inProgressDownloads) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1) {
                    // Already a download in progress
                    this.outputChannel.appendLine(` -- Concurrent download of '${acquisitionStarted.install.installId}' started!`);
                    this.outputChannel.appendLine('');
                }
                else {
                    this.startDownloadIndicator();
                }
                const startVersionString = this.inProgressDownloads.join(', ');
                this.outputChannel.append(`Downloading .NET version(s) ${startVersionString} ...`);
                break;
            case EventType_1.EventType.DotnetAcquisitionCompleted:
                const acquisitionCompleted = event;
                this.outputChannel.appendLine(' Done!');
                this.outputChannel.appendLine(`.NET ${acquisitionCompleted.install.installId} executable path: ${acquisitionCompleted.dotnetPath}`);
                this.outputChannel.appendLine('');
                this.inProgressVersionDone(acquisitionCompleted.install.installId);
                if (((_d = (_c = this.inProgressDownloads) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0) {
                    const completedVersionString = `'${this.inProgressDownloads.join('\', \'')}'`;
                    this.outputChannel.append(`Still downloading .NET version(s) ${completedVersionString} ...`);
                }
                else {
                    this.stopDownloadIndicator();
                }
                break;
            case EventType_1.EventType.DotnetAcquisitionSuccessEvent:
                if (event instanceof EventStreamEvents_1.DotnetExistingPathResolutionCompleted) {
                    this.outputChannel.append(`Using configured .NET path: ${event.resolvedPath}\n`);
                }
                break;
            case EventType_1.EventType.DotnetVisibleWarning:
                this.outputChannel.appendLine('');
                this.outputChannel.appendLine(event.eventMessage);
                this.outputChannel.appendLine('');
                break;
            case EventType_1.EventType.DotnetAcquisitionAlreadyInstalled:
                if (event instanceof EventStreamEvents_1.DotnetAcquisitionAlreadyInstalled) {
                    this.outputChannel.append(`${event.requestingExtensionId}: Trying to install .NET ${event.install.installId} but it already exists. No downloads or changes were made.\n`);
                }
                break;
            case EventType_1.EventType.DotnetAcquisitionInProgress:
                if (event instanceof EventStreamEvents_1.DotnetAcquisitionInProgress) {
                    this.outputChannel.append(`${event.requestingExtensionId} tried to install .NET ${event.install.installId} but that install had already been requested. No downloads or changes were made.\n`);
                }
                break;
            case (EventType_1.EventType.DotnetAcquisitionError, EventType_1.EventType.DotnetAcquisitionFinalError):
                const error = event;
                this.outputChannel.appendLine(`\nError : (${(_e = error === null || error === void 0 ? void 0 : error.eventName) !== null && _e !== void 0 ? _e : ''})`);
                if (this.inProgressDownloads.includes((_g = (_f = error === null || error === void 0 ? void 0 : error.install) === null || _f === void 0 ? void 0 : _f.installId) !== null && _g !== void 0 ? _g : '')) {
                    this.outputChannel.appendLine(`Failed to download .NET ${(_h = error === null || error === void 0 ? void 0 : error.install) === null || _h === void 0 ? void 0 : _h.installId}:`);
                    this.outputChannel.appendLine((_j = error === null || error === void 0 ? void 0 : error.error) === null || _j === void 0 ? void 0 : _j.message);
                    this.outputChannel.appendLine('');
                    this.updateDownloadIndicators((_k = error.install) === null || _k === void 0 ? void 0 : _k.installId);
                }
                break;
            case EventType_1.EventType.DotnetInstallExpectedAbort:
                const abortEvent = event;
                this.outputChannel.appendLine(`Cancelled Installation of .NET ${(_l = abortEvent.install) === null || _l === void 0 ? void 0 : _l.installId}.`);
                this.outputChannel.appendLine(abortEvent.error.message);
                this.updateDownloadIndicators((_m = abortEvent.install) === null || _m === void 0 ? void 0 : _m.installId);
                break;
            case EventType_1.EventType.DotnetUpgradedEvent:
                const upgradeMessage = event;
                this.outputChannel.appendLine(`${upgradeMessage.eventMessage}:`);
                break;
            case EventType_1.EventType.DotnetDebuggingMessage:
                const loggedMessage = event;
                this.outputChannel.appendLine(loggedMessage.message);
                break;
            case EventType_1.EventType.OfflineInstallUsed:
                const offlineUsedMsg = event;
                this.outputChannel.appendLine(offlineUsedMsg.eventMessage);
                break;
            case EventType_1.EventType.OfflineWarning:
                const offlineWarning = event;
                this.outputChannel.appendLine(offlineWarning.eventMessage);
                break;
            case EventType_1.EventType.DotnetUninstallMessage:
                const uninstallMessage = event;
                this.outputChannel.appendLine(uninstallMessage.eventMessage);
                break;
            case EventType_1.EventType.FeedInjectionMessage:
                const feedMessage = event;
                this.outputChannel.appendLine(feedMessage.eventMessage);
                break;
        }
    }
    dispose() {
        // Nothing to dispose
    }
    updateDownloadIndicators(installId) {
        var _a, _b;
        if (installId && installId !== 'null') {
            this.inProgressVersionDone(installId);
        }
        if (((_b = (_a = this.inProgressDownloads) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
            const errorVersionString = this.inProgressDownloads.join(', ');
            this.outputChannel.append(`Still downloading .NET version(s) ${errorVersionString} ...`);
        }
        else {
            this.stopDownloadIndicator();
        }
    }
    startDownloadIndicator() {
        this.downloadProgressInterval = setInterval(() => this.outputChannel.append('.'), 1000);
    }
    stopDownloadIndicator() {
        if (this.downloadProgressInterval) {
            clearTimeout(this.downloadProgressInterval);
            this.downloadProgressInterval = undefined;
        }
    }
    inProgressVersionDone(version) {
        const index = this.inProgressDownloads.indexOf(version);
        this.inProgressDownloads.splice(index, 1);
    }
}
exports.OutputChannelObserver = OutputChannelObserver;
//# sourceMappingURL=OutputChannelObserver.js.map